<template>
  <div class="container">
    <div class="header">
      <el-button
        type="primary"
        size="mini"
        @click="washDataComplete"
        :disabled="deleteList.length === 0"
        >清洗完成</el-button
      >
      <el-popover ref="popover1" placement="top-start" trigger="hover">
        <el-tag type="success" slot="reference" size="mini"
          >总计(查看例图) <el-badge class="mark" :value="imageList.length"
        /></el-tag>
        <div class="image-wrapper">
          <img :src="class_dish.dish_image_url" alt="" class="image-item" />
        </div>
      </el-popover>
      <el-tag type="danger" size="mini"
        >已删除<el-badge class="mark" :value="deleteList.length"
      /></el-tag>
    </div>
    <vvsl :size="80" :remain="10" :bench="50">
      <scroll-item
        :images="item"
        @delete="onDelete"
        v-for="item of image_list_chunck"
        :key="item[0].img_uuid"
      />
    </vvsl>
  </div>
</template>
<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import {apiDateMarkDelete, apiGetMigrationImages} from '@/api';
import scrollItem from './scrollItem';
import vvsl from 'vue-virtual-scroll-list';

export default {
  name: "migration",
  components: {
    vvsl,
    scrollItem
  },
  data() {
    return {
      dialogVisible: false,
      filter_type: 1,
      imageList: [],
      image_size: 10,
      deleteList: []
    };
  },
  mounted() {
    this.setSubTitle("迁移数据清洗");
    this.getMigrationImage();
  },
  methods: {
    ...mapMutations(["setSubTitle", "emitLoading", "removeLoading"]),
    viewClassDish() {},
    async washDataComplete() {
      try {
        await apiDateMarkDelete(this.deleteList, this.class_dish.class_id);
        this.$message.warning("清洗成功, 正在跳转");
        this.$router.go(-1);
      } catch (e) {
        console.log(e);
        this.$message.error("清洗失败" + e.message);
      }
    },
    onDelete(img_uuid) {
      console.log(img_uuid);
      this.deleteList.push(img_uuid);
    },
    ...mapActions([]),
    async getMigrationImage() {
      this.$confirm("提示", "请选择数据类型", {
        cancelButtonText: "迁移数据",
        confirmButtonText: "全部数据",
        type: "warning",
        distinguishCancelAndClose: true
      })
        .then(async () => {
          this.filter_type = 3;
          this.emitLoading();
          try {
            let res = await apiGetMigrationImages(
              this.class_dish.class_id,
              this.filter_type
            );
            this.imageList = res.img_info_list;
            this.removeLoading();
          } catch (e) {
            this.$message.error("获取图片失败" + e.message);
            this.removeLoading();
          }
        })
        .catch(async action => {
          if (action !== "cancel") {
            this.filter_type = 1;
            this.emitLoading();
            try {
              let res = await apiGetMigrationImages(
                this.class_dish.class_id,
                this.filter_type
              );
              this.imageList = res.img_info_list;
              this.removeLoading();
            } catch (e) {
              this.$message.error("获取图片失败" + e.message);
              this.removeLoading();
            }
          }
        });
    }
  },
  computed: {
    ...mapGetters([]),
    class_dish() {
      return this.$_.cloneDeep(this.$route.params.class_dish);
    },
    image_list_chunck() {
      return this.$_.chunk(
        this.$_.differenceWith(
          this.imageList,
          this.deleteList,
          (left, right) => left.img_uuid === right
        ),
        this.image_size
      );
    }
  },
  watch: {}
};
</script>
<style lang="scss" scoped>
.container {
  position: relative;
  .header {
    top: -35px;
  }
  .mark {
    position: relative;
    top: -10px;
  }
}
.image-wrapper {
  width: 150px;
  height: 150px;
}
</style>
